<app-loading [exibir]="carregando"></app-loading>
<div *ngIf="!carregando" class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <div style="display: flex; justify-content: space-between; align-items: center; margin: 0 5vw -5vh 5vw; padding: 0;">
      <button [disabled]="!botao" (click)="exportarPDF()" class="btn btn-outline-secondary btn-sm">
        <i class="fa fa-file"></i>
        Imprimir PDF
      </button>
      <div *ngIf="idMarca == 65 || idMarca == 40 || idMarca == 31 || idMarca == 33 || idMarca == 2">
         <button [disabled]="!botao" (click)="exportPDFMontadora()" class="btn btn-outline-secondary btn-sm">
        <i class="fa fa-file"></i>
        O.S Montadora
        </button>
      </div>
      <div *ngIf="exibirFolhaAcompanhamento">
        <button [disabled]="!botao" (click)="imprimirFolhaAcompanhamento()" class="btn btn-outline-secondary btn-sm ml-2" type="button">
          <i class="fa fa-file"></i>
          {{ 'rmpv.detalhado.detalhadoOS.btnImprimirFolhaAcompanhamento' | translate }}
        </button>
      </div>
      
      <nav class="nav nav-pills nav-fill" style="flex: 1; max-width: 60%; margin: 0 20px;">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
            aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
            {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.abaTitulo'}}
          </a>
          <a translate id="servicos-tab" href="#servicos" aria-controls="servicos" aria-selected="false"
            class="nav-item nav-link" data-toggle="tab" role="tab">
            {{'rmpv.detalhado.detalhadoOS.servicos.abaTitulo'}}
          </a>
          <a translate id="pecas-tab" href="#pecas" aria-controls="pecas" aria-selected="false" class="nav-item nav-link"
            data-toggle="tab" role="tab">
            {{'rmpv.detalhado.detalhadoOS.pecas.abaTitulo'}}
          </a>
          <a translate id="execucao-tab" href="#execucao" aria-controls="execucao" aria-selected="false"
            class="nav-item nav-link" data-toggle="tab" role="tab">
            {{'rmpv.detalhado.detalhadoOS.execucao.abaTitulo'}}
          </a>
          <a translate id="notas-tab" href="#notas" aria-controls="notas" aria-selected="false" class="nav-item nav-link"
            data-toggle="tab" role="tab">
            {{'rmpv.detalhado.detalhadoOS.notas.abaTitulo'}}
          </a>
        </div>
      </nav>
      
      <button translate [disabled]="!botao" (click)="imprimePdf()" class="btn btn-outline-secondary btn-sm">
        <em class="fa fa-download fa-xs"></em>
      </button>
    </div>
    
    <div id="print-section">
      <div class="tab-content" id="nav-tabContent">
        <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
          role="tabpanel">
          <header translate class="titulo">{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.abaTitulo'}}</header>
          <div class="container-fluid">

            <div class=" border border-info container-body">
              <div class="row row-padding">
                <em class="fa fa-info-circle icon-color" aria-hidden="true"></em>
                <h6><strong
                    translate>{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.informacaoLabel'}}</strong>
                </h6>
              </div>
              <div>
                <div class="row alinhamento-row">
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.numeroOS'}}
                    </small>
                    <h4 class="font-size-information"> {{model.numero}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.idNumeroOS'}}
                    </small>
                    <h4 class="font-size-information"> {{model.idNumeroOs || '-'}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.agendamento'}}
                    </small>
                    <h4 class="font-size-information"> {{model.numero_agendamento}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.status.statusLabel'}}
                    </small>
                    <h4 class="font-size-information">
                      {{model.status}}
                    </h4>
                  </div>
                </div>

                <div class="row alinhamento-row">
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.tipoDealer'}}
                    </small>
                    <h4 class="font-size-information"> {{model.tipo_dealer}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.tipoFabrica'}}
                    </small>
                    <h4 class="font-size-information"> {{model.tipo_fabrica}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.categoria'}}
                    </small>
                    <h4 class="font-size-information"> {{model.categoria}} </h4>
                  </div>
                  <div class="col-3">
                    <small translate class="stats-label head-item">
                      {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.garantia'}}
                    </small>
                    <h5 class="font-size-information"> {{model.solicitacao_garantia}} </h5>
                  </div>
                </div>
              </div>
              <div class="row">
                <app-check-box class="col-3 font-size-tags"
                  label="{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.retrabalho' | translate}}"
                  name="retrabalho" [(ngModel)]="model.retrabalho" [ativo]="false">
                </app-check-box>
                <app-check-box class="col-3 font-size-tags"
                  label="{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.expresso' | translate}}"
                  name="expresso" [(ngModel)]="model.expresso" [ativo]="false">
                </app-check-box>
                <app-check-box class="col-3 font-size-tags"
                  label="{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.imobilizado' | translate}}"
                  name="imobilizado" [(ngModel)]="model.imobilizado" [ativo]="false">
                </app-check-box>
                <app-check-box class="col-3 font-size-tags"
                  label="{{'rmpv.detalhado.detalhadoOS.dadosPrincipais.informacao.complemento' | translate}}"
                  name="complemento" [(ngModel)]="model.complemento" [ativo]="false">
                </app-check-box>
              </div>
              <hr class="hr-color">
              <div class="row row-padding">
                <em class="fa fa-user   icon-color" aria-hidden="true"></em>
                <h6><strong translate>
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.cliente.clienteLabel'}}
                  </strong></h6>
              </div>

              <div class="row alinhamento-row">
                <div class="col-8 alinhamento-total">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.cliente.nome'}}
                  </small>
                  <h4 class="font-size-information"> {{model.cliente.nome}} </h4>
                </div>
              </div>
              <hr class="hr-color">
              <div class="row row-padding">
                <em class="fa fa-car icon-color" aria-hidden="true"></em>
                <h6><strong translate>
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.veiculoLabel'}}
                  </strong></h6>
              </div>

              <div class="row alinhamento-row">
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.produto'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.produto || '-'}} </h4>
                </div>
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.chassi'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.chassi || '-'}} </h4>
                </div>
              </div>

              <div class="row alinhamento-row">
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.modelo'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.modelo || '-'}} </h4>
                </div>
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.km'}}
                  </small>
                  <h4 class="font-size-information"> {{model.km || '-'}} </h4>
                </div>
              </div>

              <div class="row alinhamento-row">
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.anoFabricacao'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.anoFabricacao || '-'}} </h4>
                </div>
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.placa'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.placa || '-'}} </h4>
                </div>
              </div>

              <div class="row alinhamento-row">
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.anoModelo'}}
                  </small>
                  <h4 class="font-size-information"> {{model.veiculo.anoModelo || '-'}} </h4>
                </div>
                <div class="col-6">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.blindado'}}
                  </small>
                  <h4 class="font-size-information"> 
                    {{model.veiculo.blindado ? ('rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.sim' | translate) : ('rmpv.detalhado.detalhadoOS.dadosPrincipais.veiculo.nao' | translate)}} 
                  </h4>
                </div>
              </div>
              <hr class="hr-color">
              <div class="row row-padding">
                <em class="fas fa-user-circle  icon-color" aria-hidden="true"></em>
                <h6><strong translate>
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.consultor.consultorLabel'}}
                  </strong></h6>
              </div>
              <div class="row alinhamento-row">
                <div class="col-4 alinhamento-total">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.consultor.cpfConsultor'}}
                  </small>
                  <h4 class="font-size-information" mask='00.000.000/0000-00'>
                    {{model.consultor.cpf}}
                  </h4>
                </div>
                <div class="col-8 alinhamento-total">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.consultor.nome'}}
                  </small>
                  <h4 class="font-size-information"> {{model.consultor.nome}} </h4>
                </div>
              </div>

              <hr class="hr-color">
              <div class="row row-padding">
                <em class="fas fa-dollar-sign icon-color" aria-hidden="true"></em>
                <h6><strong translate>
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresServico.valoresServicoLabel'}}
                  </strong></h6>
              </div>
              <div class="row alinhamento-row">
                <div class="col-4">
                  <small class="stats-label head-item">Total:</small>
                  <h4 class="font-size-information"> {{total_bruto_servicos}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresServico.desconto'}}
                  </small>
                  <h4 class="font-size-information"> {{desconto_servicos}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresServico.liquido'}}
                  </small>
                  <h4 class="font-size-information"> {{total_liquido_servicos}} </h4>
                </div>
              </div>

              <div class="row row-padding">
                <em class="fas fa-dollar-sign icon-color" aria-hidden="true"></em>
                <h6><strong translate>
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresPeca.valoresPecaLabel'}}
                  </strong></h6>
              </div>
              <div class="row alinhamento-row">
                <div class="col-4">
                  <small class="stats-label head-item">Total:</small>
                  <h4 class="font-size-information"> {{total_bruto_produtos}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresPeca.desconto'}}
                  </small>
                  <h4 class="font-size-information"> {{desconto_produtos}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.valoresPeca.liquido'}}
                  </small>
                  <h4 class="font-size-information"> {{total_liquido_produtos}} </h4>
                </div>
              </div>

              <div class="row row-padding">
                <em class="fas fa-chart-line icon-color" aria-hidden="true"></em>
                <h6><strong>Total: </strong></h6>
              </div>
              <div class="row alinhamento-row">
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.total.totalBruto'}}
                  </small>
                  <h4 class="font-size-information"> {{total_bruto}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.total.totalDesconto'}}
                  </small>
                  <h4 class="font-size-information"> {{total_desconto}} </h4>
                </div>
                <div class="col-4">
                  <small translate class="stats-label head-item">
                    {{'rmpv.detalhado.detalhadoOS.dadosPrincipais.total.totalLiquido'}}
                  </small>
                  <h4 class="font-size-information"> {{total_liquido}} </h4>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div id="servicos" aria-labelledby="servicos-tab" class="tab-pane fade" role="tabpanel">
          <header translate class="titulo">{{'rmpv.detalhado.detalhadoOS.servicos.abaTitulo'}}</header>
          <div class="container-fluid">
            <div class=" border border-info container-body">
              <div *ngFor="let reclamacao of model.reclamacoes">
                <div translate style="font-size: 10px; color: darkgrey">
                  {{'rmpv.detalhado.detalhadoOS.servicos.reclamacao'}}</div>
                <div style="font-size: 14px; color: rgb(85, 85, 85)">
                  <em class="fa fa-info-circle   icon-color" aria-hidden="true"></em>
                  {{reclamacao.descricao}}</div>
                <!-- Exibir apenas se algum valor presente -->
                <div *ngIf="reclamacao.utilizaKit || reclamacao.kitMontadora || reclamacao.codKitFabrica || reclamacao.codReclamacao || reclamacao.dataUltAtualizacao"
                  class="row" style="font-size: 12px; margin: 6px 0 12px 0; color: rgb(85,85,85);">
                  <div class="col-sm-2">
                <small class="stats-label head-item"><strong>Utiliza Pacote?</strong>&nbsp;<span>{{ reclamacao.utilizaKit === 'S' ? ' SIM' : reclamacao.utilizaKit === 'N' ? ' NÃO' : reclamacao.utilizaKit }}</span></small>
                  </div>
                  <div class="col-sm">
                <small class="stats-label head-item"><strong>É Pacote de Montadora?</strong>&nbsp;<span>{{ reclamacao.kitMontadora === 'S' ? ' SIM' : reclamacao.kitMontadora === 'N' ? ' NÃO' : reclamacao.kitMontadora }}</span></small>
                  </div>
                  <div class="col-sm">
                <small class="stats-label head-item"><strong>Pacote Aplicado:</strong>&nbsp;<span>{{ reclamacao.codKitFabrica }}</span></small>
                  </div>
                  <div class="col-sm-2">
                <small class="stats-label head-item"><strong>Cod. Pac. NBS:</strong>&nbsp;<span>{{ reclamacao.codReclamacao }}</span></small>
                  </div>
                  <div class="col-sm">
                <small class="stats-label head-item"><strong>Atualizado em:</strong>&nbsp;<span>{{ reclamacao.dataUltAtualizacao | date:'short' }}</span></small>
                  </div>
                </div>
                <div *ngIf="reclamacao.servicos.length > 0" class="row"
                  style="font-size: 12px; background-color: white; color: black; font-weight: bold; padding: 6px; margin: 0px 0px 6px 0px;">
                  <div translate class="col-sm-4">
                    {{'rmpv.detalhado.detalhadoOS.servicos.Opcoes'}}
                  </div>
                  <div translate class="col-sm-3">
                    {{'rmpv.detalhado.detalhadoOS.servicos.valorPadrao'}}
                  </div>
                  <div translate class="col-sm-3">
                    {{'rmpv.detalhado.detalhadoOS.servicos.valorCobrado'}}
                  </div>
                </div>
                <div *ngFor="let servico of reclamacao.servicos">
                  <div class="row descricao-servico" style="font-size: 14px;">
                    <div class="col-sm-3">
                      <strong>{{servico.codigo}}</strong>
                    </div>
                    <hr class="hr-color">
                    <div class="col-sm-9">
                      <strong [translate]="getTranslate(servico.descricao)"></strong>
                    </div>
                    <hr class="hr-color">
                  </div>
                  <div class="row" style="font-size: 12px; margin: 0px 0px 0px 12px;">
                    <div class="col-sm-2">
                      <input class="form-check-input" type="checkbox" name="topix" id="topix"
                        [(ngModel)]="servico.topix" disabled>
                      <label translate class="form-check-label" for="topix">
                        Topix
                      </label>
                      <br>
                      <input class="form-check-input" type="checkbox" name="evhc" id="evhc" [(ngModel)]="servico.evhc"
                        disabled>
                      <label translate class="form-check-label" for="evhc">
                        E-Vhc
                      </label>
                      <br>
                      <input class="form-check-input" type="checkbox" name="terceiro" id="terceiro"
                        [(ngModel)]="servico.terceiro" disabled>
                      <label translate class="form-check-label" for="terceiro">
                        {{'rmpv.detalhado.detalhadoOS.servicos.checkbox.terceiro'}}
                      </label>
                    </div>
                    <div class="col-sm-4">
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.classe'}}</strong>
                      {{reclamacao.classe}} 
                      <br>
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.causa'}}</strong>
                      {{reclamacao.causa}}<br>
                    </div>
                    <div class="col-sm-3">
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.valor'}}</strong>
                      {{servico.valor_padrao}}<br>
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.TMO'}}</strong>
                      {{servico.tmo_padrao}}<br>
                    </div>
                    <div class="col-sm-2">
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.valor'}}</strong>
                      {{servico.valor_cobrado}}<br>
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.TMO'}}</strong>
                      {{servico.tmo_cobrado}}<br>
                      <strong translate>{{'rmpv.detalhado.detalhadoOS.servicos.desconto'}}</strong>
                      {{servico.valor_desconto}}<br>
                    </div>
                  </div>
                  <hr class="hr-color">
                </div>
                <div translate *ngIf="reclamacao.servicos.length == 0" style="font-size: 12px;">
                  {{'rmpv.detalhado.detalhadoOS.servicos.naoHaServicoReclamacao'}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="pecas" aria-labelledby="pecas-tab" class="tab-pane fade" role="tabpanel">
          <header translate class="titulo">{{'rmpv.detalhado.detalhadoOS.pecas.abaTitulo'}}</header>
          <div class="container-fluid">
            <div class=" border border-info container-body">
              <div translate class="sem-dados-grid" *ngIf="reclamacao">
                {{'rmpv.detalhado.detalhadoOS.pecas.nenhumRegistoExibir'}}
              </div>
              <div>
                <div *ngFor="let reclamacao of model.reclamacoes">
                  <div *ngFor="let servico of reclamacao.servicos">
                    <div *ngFor="let requisicao of servico.requisicoes">
                      <div translate style="font-size: 10px; color: darkgrey">
                        {{'rmpv.detalhado.detalhadoOS.pecas.requisicao'}}
                      </div>
                      <div style="font-size: 20px; color: rgb(85, 85, 85)">
                        {{requisicao.numero}} &nbsp;&nbsp;
                        <span translate style="font-size: 14px;">
                          {{'rmpv.detalhado.detalhadoOS.pecas.data'}}
                          <ng-container>
                            {{ formatDate(requisicao.data) | date: 'shortDate' }}
                          </ng-container>
                        </span>
                      </div>
                      <app-gridview [totalInterna]="false" [totalGeral]="false" [visualizarTotalRegistros]="false"
                        [PaginaAtual]="paginaAtual" [QuantidadeRegistrosPorPagina]="QuantidadeRegistrosPorPagina"
                        [Paginacao]="listagemComPaginacao" [Estrutura]="estruturaPecas"
                        [Dados]="carregarPecas(requisicao.pecas)" [EstruturaInterna]="estruturaInterna"
                        [EstruturaTotal]="estruturaTotal" [total_registros]="total_registros"
                        [ListagemComFiltros]="listagemComFiltros" (ver)="ver($event)" [visualizarTotalRegistros]="false"
                        (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)"
                        (mudarPaginaAtual)="mudarPaginaAtual($event)">
                      </app-gridview>
                      <hr class="hr-color">
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div id="execucao" aria-labelledby="execucao-tab" class="tab-pane fade" role="tabpanel">

          <header class="titulo">{{'rmpv.detalhado.detalhadoOS.execucao.abaTitulo'}}</header>
          <div class="container-fluid">

            <div class=" border border-info container-body">
              <div translate class="sem-dados-grid" *ngIf="execucao">
                {{'rmpv.detalhado.detalhadoOS.execucao.nenhumRegistroExibir'}}
              </div>

              <div *ngFor="let reclamacao of model.reclamacoes">
                <div *ngFor="let servico of reclamacao.servicos">
                  <div translate style="font-size: 10px; color: darkgrey">
                    {{'rmpv.detalhado.detalhadoOS.execucao.servico'}}
                  </div>
                  <div style="font-size: 20px; color: rgb(85, 85, 85)">{{servico.codigo}} &nbsp;
                    <span [translate]="getTranslate(servico.descricao)"
                      style="font-size: 14px; font-style: italic;">&nbsp;
                    </span>
                  </div>
                  <app-gridview [totalInterna]="false" [totalGeral]="false" [visualizarTotalRegistros]="false"
                    [PaginaAtual]="paginaAtual" [QuantidadeRegistrosPorPagina]="QuantidadeRegistrosPorPagina"
                    [Paginacao]="listagemComPaginacao" [Estrutura]="estruturaExecucao"
                    [Dados]="carregarExecucoes(servico.tempoExecutado)" [EstruturaInterna]="estruturaInterna"
                    [EstruturaTotal]="estruturaTotal" [total_registros]="total_registros"
                    [ListagemComFiltros]="listagemComFiltros" (ver)="ver($event)" [visualizarTotalRegistros]="false"
                    (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)"
                    (mudarPaginaAtual)="mudarPaginaAtual($event)">
                  </app-gridview>
                  <div translate *ngIf="servico.tempoExecutado.length == 0" style="font-size: 12px;">
                    {{'rmpv.detalhado.detalhadoOS.execucao.naoRegistradaExecucao'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="notas" aria-labelledby="notas-tab" class="tab-pane fade" role="tabpanel">
          <header translate class="titulo">{{'rmpv.detalhado.detalhadoOS.notas.abaTitulo'}}</header>
          <div class="container-fluid">
            <div class=" border border-info container-body">
              <app-gridview [totalInterna]="false" [totalGeral]="false" [PaginaAtual]="paginaAtual"
                [QuantidadeRegistrosPorPagina]="QuantidadeRegistrosPorPagina" [Paginacao]="listagemComPaginacao"
                [Estrutura]="estruturaNotas" [Dados]="notas" [EstruturaInterna]="estruturaInterna"
                [EstruturaTotal]="estruturaTotal" [total_registros]="total_registros"
                [ListagemComFiltros]="listagemComFiltros" (ver)="ver($event)" [visualizarTotalRegistros]="false"
                (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)"
                (mudarPaginaAtual)="mudarPaginaAtual($event)">
              </app-gridview>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>